import BaseApi from "../baseApi";
import {CODE} from "../apiConstant";

const apiWorkManage = new BaseApi(process.env.REACT_APP_PROJECT_MANAGEMENT_API_URL);

class CodeApi {
  getListByCodeTypeNumber(request) {
    return apiWorkManage.post(`${CODE}/codes-by-type-number`, request);
  }

}

export default CodeApi;